<template lang="html">
    <div class="view-account">

        <PageTitle text="Mon compte">
        </PageTitle>

        <div class="layout-width padding">
            <el-row :gutter="20">
                <el-col
                    :xs="24"
                    :sm="12">

                    <!-- current user info -->
                    <el-card
                        v-if="currentUser"
                        class="box-card info-card-height">
                        <div
                            slot="header"
                            class="edf-card-header">
                            <span>Mes coordonnées</span>
                        </div>
                        <dl class="description-list">
                            <dt>Prénom et nom</dt>
                            <dd>{{ currentUser.first_name }} {{ currentUser.last_name }}</dd>
                            <div  v-if="!$store.getters.isApiValoUsed">
                                <dt>Email</dt>
                                <dd><a :href="'mailto:' + currentUser.email">{{ currentUser.email }}</a></dd>
                            </div>
                            <div v-else>
                                <dt>NNi</dt>
                                <dd>{{ currentUserName }}</dd>
                            </div>
                        </dl>
                    </el-card>
                </el-col>
            </el-row>

            <ButtonLogout></ButtonLogout>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/partials/ui/PageTitle';
import ButtonLogout from './ButtonLogout';
import { mapGetters } from 'vuex';
export default {
    name: 'Account',
    components: {
        PageTitle,
        ButtonLogout,
    },
    data () {
        return {};
    },
    computed: {
        ...mapGetters([
            'currentUser',
            'userByUid',
        ]),
        currentUserName(){
            let email = this.currentUser.email;
            let nni = email.replace(window.config.email_suffix, '');
            return nni;
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logoutUser');
            this.$router.push('/');
        },
    }
};
</script>

<style lang="scss">
.ns-vue-loader{
    .info-card-height{
        min-height: 2px;
        .el-card__body{
            min-height: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Account/Account.vue